
# This feels haxy. Maybe should fork handsontable add this The Right Way(TM)?
window.Handsontable.Core.prototype.getRowOfSourceData = (obj, guess = null) ->
    # Guess can be used to shortcut the costly loop over the entire array. This
    # should be the index of the item in the source data array if the table
    # sorting hasn't changed. Just make sure we got it right.
    if guess? and @getSourceDataAtRow(guess) is obj
        return guess

    # If the table sorting changed or for whatever reason the guess is wrong,
    # then we have to go looking for it.
    for row in [0 .. @countRows() - 1]
        if @getSourceDataAtRow(row) is obj
            return row

    # I couldn't find the object. I'm sorry. I tried.
    return -1
